import { objectToString } from '../../../../utils/objectToString/objectToString/index.js';
import { generateTheme } from '../../../../colors/themes/themes/index.js';

/**
 * Generates CSS styles based on themes.
 * @param themes - An array of theme objects.
 * @returns A string containing CSS rules.
 */
function getColorsStyles({ themes }) {
    return themes
        .map(({ key, value }) => `:root.${key} { ${objectToString(generateTheme(value))} }`)
        .join(' ');
}
/**
 * Applies and manages theme classes on the document root.
 * For SSR, injects classes into the provided HTML string.
 * For CSR, adds/removes classes dynamically.
 *
 * @param themes - An array of theme objects.
 * @param ssrHtml - Optional: HTML string for SSR.
 * @returns A cleanup function (CSR) or modified HTML string (SSR).
 */
function applyThemeClasses({ themes }, ssrHtml) {
    if (ssrHtml !== undefined) {
        const themeClasses = themes
            .reduce((acc, theme) => (theme.selected ? `${acc} ${theme.key}` : acc), '')
            .trim();
        return themeClasses
            ? ssrHtml.replace('<html', `<html class="${themeClasses}"`)
            : ssrHtml;
    }
    if (typeof document !== 'undefined') {
        const htmlElement = document.documentElement;
        themes?.forEach((theme) => {
            if (theme.selected) {
                htmlElement.classList.add(theme.key);
            }
        });
        return () => {
            themes?.forEach((theme) => {
                htmlElement.classList.remove(theme.key);
            });
        };
    }
    return '';
}

export { applyThemeClasses, getColorsStyles };
